// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"Home_homeContainer__1Zn4C","articleHome":"Home_articleHome__26K2-","text-focus-in":"Home_text-focus-in__YolLJ","textHome":"Home_textHome__3XUVs"};